//
//
//
//

import { mapGetters } from 'vuex'

const nitro = window.nitroAds
let videoAdStarted = false

export default {
    name: 'NitroPayAdController',

    computed: {
        ...mapGetters(['showStreamPreview']),
    },

    methods: {
        /**
         * This is called by the router whenever the page is changed. It is not
         * when the router detects the URL changed but the page hasn't
         * (i.e. when clicking on different groups).
         */
        pageChanged(to, from) { // eslint-disable-line no-unused-vars
            Object.values(this.$ads).forEach((ad) => {
                try {
                    ad.onNavigate()
                } catch (e) {
                    console.error('Error while refreshing ad', ad, e)
                }
            })
        },

        async createAd(type, params) {
            try {
                const ad = await nitro.createAd(type, params)
                this.$ads[type] = ad
            } catch (e) {
                console.error(`Error while creating ${type} ad`, e)
            }
        },

        createVideoAd() {
            if (this.$ads.video || videoAdStarted) return
            videoAdStarted = true
            this.createAd('video', {
                refreshLimit: 0,
                refreshTime: 60,
                format: 'floating',
                mediaQuery: '(min-width: 0px)',
                report: {
                    enabled: true,
                    icon: true,
                    wording: 'Report Ad',
                    position: 'top-right',
                },
                floating: {
                    position: 'right',
                    reduceMobileSize: true,
                },
            })
        },

        destroyVideoAd() {
            if (!this.$ads.video) return
            this.$ads.video.destroy()
        },
    },

    mounted() {
        this.$ads = {}

        if (!this.showStreamPreview) this.createVideoAd()

        // Bottom Anchor
        // this.createAd('stickyfooter', {
        //     refreshLimit: 0,
        //     refreshTime: 30,
        //     format: 'anchor',
        //     anchor: 'bottom',
        //     anchorBgColor: 'rgba(245,245,245,.15)',
        //     anchorPersistClose: false,
        //     mediaQuery: '(min-width: 0px)',
        //     report: {
        //         enabled: true,
        //         icon: true,
        //         wording: 'Report Ad',
        //         position: 'top-right',
        //     },
        // })

        this.$listenFor('pageChanged', this.pageChanged)
    },

    watch: {
        showStreamPreview(newValue) {
            if (newValue) {
                this.destroyVideoAd()
            } else if (this.$ads.video) {
                this.$ads.video.refresh()
            } else {
                this.createVideoAd()
            }
        },
    },
}
